import { render, staticRenderFns } from "./M2hNews.vue?vue&type=template&id=38f6db7e&scoped=true&"
import script from "./M2hNews.vue?vue&type=script&lang=js&"
export * from "./M2hNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f6db7e",
  null
  
)

export default component.exports